var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoRights({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1080,
    height: 575,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "400 0 500 700",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 148)"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#6BA5B4",
    cx: 296.5,
    cy: 213.5,
    r: 55.5
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#6BA5B4",
    cx: 537.5,
    cy: 213.5,
    r: 55.5
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E74536",
    cx: 55.5,
    cy: 213.5,
    r: 55.5
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#2175D9",
    cx: 658.5,
    cy: 361.5,
    r: 55.5
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#2175D9",
    cx: 175.5,
    cy: 65.5,
    r: 55.5
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E74536",
    cx: 899.5,
    cy: 361.5,
    r: 55.5
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFB511",
    cx: 175.5,
    cy: 361.5,
    r: 55.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.92 153.434A18.78 18.78 0 0 0 398.69 148c-10.29 0-18.69 8.36-18.69 18.601 0 5.12 2.1 9.719 5.46 13.167L418.85 213l-33.39 33.232a18.602 18.602 0 0 0-5.46 13.167c0 10.24 8.4 18.601 18.69 18.601 5.145 0 9.765-2.09 13.23-5.434l46.62-46.399A18.602 18.602 0 0 0 464 213c0-5.12-2.1-9.719-5.46-13.167l-46.62-46.399zM170.92 153.434A18.78 18.78 0 0 0 157.69 148c-10.29 0-18.69 8.36-18.69 18.601 0 5.12 2.1 9.719 5.46 13.167L177.85 213l-33.39 33.232a18.602 18.602 0 0 0-5.46 13.167c0 10.24 8.4 18.601 18.69 18.601 5.145 0 9.765-2.09 13.23-5.434l46.62-46.399A18.602 18.602 0 0 0 223 213c0-5.12-2.1-9.719-5.46-13.167l-46.62-46.399zM532.92 302.434A18.78 18.78 0 0 0 519.69 297c-10.29 0-18.69 8.36-18.69 18.601 0 5.12 2.1 9.719 5.46 13.167L539.85 362l-33.39 33.232a18.602 18.602 0 0 0-5.46 13.167c0 10.24 8.4 18.601 18.69 18.601 5.145 0 9.765-2.09 13.23-5.434l46.62-46.399A18.602 18.602 0 0 0 585 362c0-5.12-2.1-9.719-5.46-13.167l-46.62-46.399zM290.92 302.434A18.78 18.78 0 0 0 277.69 297c-10.29 0-18.69 8.36-18.69 18.601 0 5.12 2.1 9.719 5.46 13.167L297.85 362l-33.39 33.232a18.602 18.602 0 0 0-5.46 13.167c0 10.24 8.4 18.601 18.69 18.601 5.145 0 9.765-2.09 13.23-5.434l46.62-46.399A18.602 18.602 0 0 0 343 362c0-5.12-2.1-9.719-5.46-13.167l-46.62-46.399zM578.54 51.833 531.92 5.434A18.78 18.78 0 0 0 518.69 0C508.4 0 500 8.36 500 18.601c0 5.12 2.1 9.719 5.46 13.167L538.85 65l-33.39 33.232a18.602 18.602 0 0 0-5.46 13.167c0 10.24 8.4 18.601 18.69 18.601 5.145 0 9.765-2.09 13.23-5.434l46.62-46.399A18.602 18.602 0 0 0 584 65c0-5.12-2.1-9.719-5.46-13.167zM49.92 5.434A18.78 18.78 0 0 0 36.69 0C26.4 0 18 8.36 18 18.601c0 5.12 2.1 9.719 5.46 13.167L56.85 65 23.46 98.232A18.602 18.602 0 0 0 18 111.399C18 121.639 26.4 130 36.69 130c5.145 0 9.765-2.09 13.23-5.434l46.62-46.399A18.602 18.602 0 0 0 102 65c0-5.12-2.1-9.719-5.46-13.167L49.92 5.434zM773.92 302.434A18.78 18.78 0 0 0 760.69 297c-10.29 0-18.69 8.36-18.69 18.601 0 5.12 2.1 9.719 5.46 13.167L780.85 362l-33.39 33.232a18.602 18.602 0 0 0-5.46 13.167c0 10.24 8.4 18.601 18.69 18.601 5.145 0 9.765-2.09 13.23-5.434l46.62-46.399A18.602 18.602 0 0 0 826 362c0-5.12-2.1-9.719-5.46-13.167l-46.62-46.399z",
    fill: "#0F1941"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoRights);
export default __webpack_public_path__ + "static/media/NoRights.57d424e5.svg";
export { ForwardRef as ReactComponent };